import React from 'react';
import "./About_Banner.css";

function About_Banner() {
  return (
    <section className='about_banner'>
      <div className='banner_wrapper'>
        <img 
          src='/assets/images/about_us/about-banner/about-banner.png' 
          alt='About us banner' 
          className='banner' 
        />
      </div>
    </section>
  );
}

export default About_Banner;